<template lang="pug">
#modal-validacao-territorio
    el-dialog.modal-argentina(
        :visible.sync='show',
        :before-close='closeDialog',
        :close-on-click-modal='false'
    )
        i.mdi.mdi-check-circle
        strong {{ $t('mensagens.territorio.territorioArgentina.territorioAprovado') }}
        .footer-territorio
            el-button(type='secondary', @click='closeDialog') {{ $t('mensagens.territorio.territorioArgentina.fecharModal') }}
</template>

<script>
export default {
    name: 'ModalTerritorioAdicionadoAR',
    components: {},
    props: {
        show: {
            type: Boolean,
            required: true
        }
    },
    emits: ['close'],
    methods: {
        closeDialog() {
            this.$emit('close');
        }
    }
};
</script>

<style lang="scss">
.modal-argentina {
    .el-dialog__header {
        background-color: white !important;
    }
    .el-dialog__body {
        display: flex;
        flex-direction: column;
        i {
            font-size: 60px;
            text-align: center;
            color: #359138;
            line-height: 1;
            margin-top: 30px;
        }
        strong {
            text-align: center;
            margin: 5px 0 15px 0;
            font-weight: 500;
            font-family: Roboto;
            color: #359138;
            font-size: 16px;
        }
        .footer-territorio {
            margin-top: 10px;
            border-top: 1px solid #e0e0e0;
            padding: 8px 15px;
            display: flex;
            justify-content: center;
        }
    }
}
</style>
